module.exports = __webpack_public_path__ + "media/images/salespartner/mv-results-8bb64e70774a43caea7f1be26c205a4f.svg";